module.exports = __webpack_public_path__ + "img/login-icon.c0724e0.svg";